/* ps-collection-chips.js
 *
 * THE SIZES MAP IS GENERATED by tools/build_size_chips.py. THE CODE IS NOT.
 * Only the single line between the BEGIN/END GENERATED MAP markers below may be
 * rewritten by the generator -- everything else is hand-maintained. The banner
 * used to say "GENERATED ... do not hand-edit" for the whole file, which meant
 * the next regeneration would have silently reverted the three fixes made
 * 2026-08-17 (observer placement, ARIA nesting, self-retriggering observer).
 *
 * Adds size chips to Impulse's product cards on collection and search pages,
 * so they match the cards in the ps-collection-rail carousel.
 *
 * WHY A SCRIPT AT ALL. Impulse's snippets/product-grid-item.liquid renders
 * colour swatches and has no size affordance, and that file is not editable --
 * a theme update would overwrite it. This adds to the rendered card instead of
 * changing how the card is built, so nothing of Impulse's is touched.
 *
 * NO NETWORK. The map below is baked at build time. A runtime fetch would add
 * a request to a page already carrying 554 KB of HTML.
 *
 * LAYOUT SHIFT -- NOT RESERVED, AND THAT IS A DECISION. An earlier version of
 * this header claimed ".grid-product__meta reserves the chip row's height in
 * CSS". That was false, and the 2026-08-17 audit proved it: "ps-chips" appears
 * ZERO times in the deployed 738,821 B theme.css. But the correction that
 * followed was wrong too -- it said the reserving rule "belongs in
 * primostore-system.css". It does not. That file already considered this and
 * decided AGAINST it, in writing: only 47 of 325 products carry a
 * size-and-no-colour option, so reserving a chip row on every card would put
 * ~22px of dead space under 278 of them to spare a shift on 47.
 *
 * So: no height is reserved, on purpose. This script runs at DOMContentLoaded,
 * before first contentful paint, so the row is normally present when the card
 * first appears. If a slow connection ever makes the shift visible, the fix is
 * to reserve on .grid-product__meta and accept the dead space on the other 85%
 * -- a trade, not a bug fix.
 *
 * Products with a COLOUR option are deliberately absent from the map: one
 * option row per card, colour wins. Abdo's ruling 2026-08-15. So a card with no
 * chips is usually CORRECT, not a miss -- 53 products carry a size option, 5 of
 * those also carry colour and are excluded on purpose, 1 has a single-value
 * option which is not a choice, leaving the 47 keys below. There is deliberately
 * NO fallback or "unknown product" path in this file: inventing one would
 * override the colour rule at runtime.
 */
(function () {
  "use strict";

  /* --- BEGIN GENERATED MAP (build_size_chips.py rewrites this line only) --- */
  var SIZES = {"dunya-slim-rectangular-pedal-dustbin-plastic-trash-can-with-pedal-15-liter-25-liter-40-liter-beige":["15 Liter","25 Liter","40 Liter"],"stainless-steel-corner-bathroom-shelf-rustproof-black":["1 Tier","2 Tier","3 Tier"],"stainless-steel-corner-bathroom-shelf-rustproof-gold":["1 Tier","2 Tier","3 Tier"],"dunya-slim-rectangular-pedal-dustbin-plastic-trash-can-with-pedal-15-liter-25-liter-40-liter":["15 Liter","25 Liter","40 Liter"],"clear-plastic-royal-storage-box-airtight-clip-cover-food-container-1-2-liter-5-7-liter-beige":["1.2 Liter","5.7 Liter"],"clear-plastic-royal-storage-box-airtight-clip-cover-food-container-dark-gray":["1.2 Liter","5.7 Liter"],"clear-plastic-royal-storage-box-airtight-clip-cover-food-container-gray":["1.2 Liter","5.7 Liter"],"toilet-paper-holder-wall-mounted-open-chrome-single-roll":["Square","Circle"],"wall-mounted-toilet-paper-holder-with-cover-chrome-single-roll":["Square","Circle"],"ribbed-plastic-mixing-bowl-non-slip-utility-basin":["1 Liter","3 Liter"],"robbed-plastic-mixing-bowl-with-non-slip-grip":["2 Liter","5 Liter"],"reusable-storage-container-box":["10 Liters","7.5 Liters","5 Liters"],"melamine-rectangular-serving-tray":["Small","Medium","Large"],"rocket-tt-super-lubricant-spray-for-maintenance-and-rust-removal-for-moving-and-stationary-mechanical-parts":["100 ml","300 ml","450 ml"],"square-storage-jar-with-tight-bamboo-lid-1":["1.5 Liters","1 Liters","0.5 Liters"],"square-spice-jars-with-spoon-and-wood-stand":["Set of 3","Set of 4"],"square-food-container-with-silicone-lid":["1.7 Liters","1.2 Liters","550 ML"],"spices-set-with-spoons-and-natural-wood-stand":["Set of 4","Set of 3"],"spice-jars-set-with-bamboo-lids":["Set of 3","Set of 4"],"sliding-food-storage-with-movable-lid":["1.25 Liters","1.8 Liters","2.7 Liters"],"set-of-white-plastic-storage-jars-with-a-wooden-lid-with-a-stand-and-wooden-spoons":["Set of 3","Set of 4"],"set-of-3-transparent-storage-jars-with-a-wooden-lid-with-a-stand-and-wooden-spoons":["Circle","Concave","Oval"],"royal-plastic-storage-box":["1.2 Liters","5.7 Liters","12 Liters"],"round-storage-jar-with-tight-bamboo-lid-1":["0.9 Liters","1.5 Liters","2 Liters"],"round-plastic-food-containers":["850 ML","1225 ML","1700 ML","2425 ML"],"plastic-drain-container-with-a-strainer":["0.8 Liters","1.6 Liters"],"glass-jar-with-a-wooden-lid-to-preserve":["550 ML","750 ML","950 ML"],"fresco-transparent-lunch-box-with-blue-clips-m-design":["1.1 Liters","1.6 Liters","2.1 Liters"],"fresco-lunch-box-blue-with-divided-compartments-m-design":["1.1 Liters","1.6 Liters","2.1 Liters"],"food-container-with-silicone-lid-1-piece":["2100 ml","1400 ml","1100 ml","700 ml"],"dunya-plastic-refrigerator-organizer-bin":["Small-30 x 12.8 x 14 cm","Large-30*20*14 cm"],"acrylic-refrigerator-organizer-bins-for-fridge":["20 x 32.5 x 7 cm","20 x 15 x 10 cm","20 x 32.5 x 14 cm"],"3-pcs-glass-sealed-jars-with-bamboo-lids":["Round","Square"],"slim-trash-can-with-swing-lid":["50 Liters","35 Liters"],"silver-turkish-stainless-steel-basket-with-pedal":["12 Liters","8 Liters","5 Liters"],"silver-swing-wastebasket-bin-durable-stainless-steel":["8 Liters","16 Liters","27 Liters","32 Liters","+1"],"kitchen-utensil-holder-from-ikea":["Small","Large"],"flosoft-plastic-basket-trash-can-with-pedal":["10 liters","20 liters","30 liters","40 liters"],"flosoft-plastic-basket-trash-can-with-pedal-varies-size":["10 liters","20 liters","30 liters","40 liters"],"dunya-basket-recycle-bin-with-swing-lid":["18 liters","35 liters","50 liters"],"black-turkish-stainless-steel-basket-with-pedal":["5 liters","12 liters"],"flosoft-plastic-wall-mount-liquid-soap-dispenser-transparent-varies-in-capacity":["350 ML","650 ML"],"flosoft-liquid-soap-dispenser-white-transparent-varies-in-capacity":["500 ML","1000 ML"],"shower-corner-organizer-shelf-1-tier":["1 Tier","2 Tier","3 Tier"],"foldable-laundry-dryer-7-ropes":["60 cm","80 cm"],"aluminum-bathroom-corner-shelf-wall-mounted":["1 Tier","2 Tier","3 Tier"],"brushed-stainless-steel-tissue-dispenser-wall-mounted":["200 paper","300 paper"]};
  /* --- END GENERATED MAP --- */

  if (!Object.keys(SIZES).length) return;

  /* Own-property lookups only. A product handle is attacker-controlled-ish text
     from the URL, so SIZES["constructor"] or SIZES["__proto__"] would otherwise
     hand back an inherited Function and sail past a plain truthiness check --
     which is why every map read below goes through has(). */
  function has(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
  }

  /* ---------------------------------------------------------------- labels -- */

  /* Canonical unit spellings, in ONE table so there is one place to change them.
     WHY THIS EXISTS: the generated map genuinely mixes Liter (9) / Liters (25) /
     liters (9) / ml (7) / ML (12) / unspaced 60cm, so on one row a shopper reads
     "15 Liter", on the next "10 liters", on the next "550ML". Normalising at
     render time keeps the chips consistent without touching the map, which is
     regenerated by Python and would lose any edit made here.
     "liter" is a sentinel, not an output -- see literWord(). */
  var UNIT_CANON = {
    "l": "liter", "ltr": "liter", "liter": "liter", "liters": "liter",
    "litre": "liter", "litres": "liter",
    "لتر": "liter", "ليتر": "liter",
    "ml": "ml", "mls": "ml",
    "milliliter": "ml", "millilitre": "ml", "milliliters": "ml", "millilitres": "ml",
    "cm": "cm", "mm": "mm", "kg": "kg", "g": "g"
  };

  /* The Arabic page is served <html lang="ar" dir="ltr"> today -- confirmed in
     the 2026-08-17 audit -- so locale MUST be read from lang/pathname and never
     from document.dir, which would report every Arabic shopper as English. */
  var isArabic = (function () {
    var lang = (document.documentElement.getAttribute("lang") || "").toLowerCase();
    return lang.indexOf("ar") === 0 || /^\/ar(\/|$)/.test(window.location.pathname);
  })();

  /* Standing Arabic ruling: the store spells it لتر, NEVER ليتر. Do not
     "correct" this to the longer spelling. */
  function literWord() {
    return isArabic ? "لتر" : "L";
  }

  var ARABIC_INDIC = /[٠-٩۰-۹]/g;
  var LETTER = /[A-Za-z؀-ۿ]/;
  var DIGIT_GLUED_TO_LETTERS = /(\d)([A-Za-z؀-ۿ]+)/g;
  var NUMERIC = /^\d+(?:\.\d+)?$/;
  var OVERFLOW = /^\+\d+$/;

  /* Standing rule: digits stay Latin 0-9, never Arabic-Indic ٠-٩ or ۰-۹. The
     map is Latin today; this is a guard against a future generator run picking
     up Arabic option values from Odoo. */
  function toLatinDigits(s) {
    return s.replace(ARABIC_INDIC, function (d) {
      var code = d.charCodeAt(0);
      return String.fromCharCode(48 + (code - (code >= 0x06F0 ? 0x06F0 : 0x0660)));
    });
  }

  /* WHAT COUNTS AS A RENDERABLE CHIP. The map is generated and is known dirty,
     so the rule is stated here rather than assumed:

       1. "+3", "+1"  -> KEPT, as an overflow counter, not a size. The generator
          caps at MAX_CHIPS = 4 and appends "+N" for the remainder, deliberately
          matching the ps-collection-rail carousel. Filtering it out would delete
          the only "there are more sizes" signal on the card. Today exactly one
          entry has it: silver-swing-wastebasket-bin-durable-stainless-steel.
       2. A value with NO letter at all -> DROPPED. This is the
          aluminum-bathroom-corner-shelf-wall-mounted case, ["1","2","3"], which
          is a Tier count that lost the word "tier". Bare numerals next to a card
          reading "1 Tier / 2 Tier / 3 Tier" mean nothing.
       3. Digits glued to letters -> KEPT ONLY IF the letters are a known unit.
          "850ML", "60cm" are real values needing spacing, so they render as
          "850 ml", "60 cm". "200paper" (brushed-stainless-steel-tissue-dispenser)
          is not a unit, so it is DROPPED rather than guessed at -- the missing
          space and Arabic unit are a DATA bug and the fix belongs in
          build_size_chips.py, not here. This file never repairs a value, it only
          normalises units and refuses what it cannot vouch for.

     Returns the display string, or null to skip. */
  function labelFor(raw) {
    if (typeof raw !== "string") return null;

    var s = toLatinDigits(raw).replace(/\s+/g, " ").trim();
    if (!s) return null;
    if (OVERFLOW.test(s)) return s;                 /* rule 1 */
    if (!LETTER.test(s)) return null;               /* rule 2 */

    /* rule 3: refuse unknown glued suffixes, space + normalise known units */
    var refused = false;
    s = s.replace(DIGIT_GLUED_TO_LETTERS, function (m, digit, word) {
      var key = word.toLowerCase();
      if (!has(UNIT_CANON, key)) { refused = true; return m; }
      return digit + " " + word;
    });
    if (refused) return null;

    var parts = s.split(" ");
    for (var i = 1; i < parts.length; i++) {
      /* A unit only counts as a unit when it follows a number, so the standalone
         "L" of a future "L / XL" size run is never turned into litres. */
      if (!NUMERIC.test(parts[i - 1])) continue;
      var key = parts[i].toLowerCase();
      if (!has(UNIT_CANON, key)) continue;
      parts[i] = UNIT_CANON[key] === "liter" ? literWord() : UNIT_CANON[key];
    }
    return parts.join(" ");
  }

  /* ----------------------------------------------------------------- cards -- */

  function handleFrom(href) {
    var m = /\/products\/([^/?#]+)/.exec(href || "");
    return m ? m[1] : null;
  }

  /* The chip row must land OUTSIDE the card's <a>. Impulse's live markup nests
     .grid-product__meta (title, review badge, price) INSIDE
     <a class="grid-product__link">, and a link's accessible name is computed from
     its whole subtree -- so appending there made the card announce as "Plastic
     Bathroom Set 5 Pieces Rose-gold Frame Okyanus, No reviews, LE 1,780.00,
     15 Liter 25 Liter 40 Liter, link". Walking up from the meta to the anchor
     (rather than hard-coding .grid-product__link) means a theme update that moves
     the meta out of the link degrades to a plain append instead of breaking. */
  function insertRow(card, row) {
    var meta = card.querySelector(".grid-product__meta");
    var anchor = null;
    for (var node = meta; node && node !== card; node = node.parentNode) {
      if (node.tagName === "A") anchor = node;
    }
    if (anchor && anchor.parentNode) {
      anchor.parentNode.insertBefore(row, anchor.nextSibling);
    } else {
      (meta || card).appendChild(row);
    }
  }

  function buildRow(vals) {
    var row = document.createElement("div");
    row.className = "ps-chips";

    /* Chips are a left-to-right run of Latin numerals whatever the page language.
       The Arabic storefront is dir="ltr" today (a separate locale bug), and when
       that is fixed an RTL row would flip ["15 L","25 L","40 L"] so a shopper
       reads 40 / 25 / 15. Pinning the row to ltr costs nothing now and prevents
       that regression later. */
    row.setAttribute("dir", "ltr");

    /* NO role="list"/"listitem". They were invalid where the row used to be
       injected (inside an <a>), they buy a sighted shopper nothing, and keeping
       them would force an English "Available sizes" label onto the Arabic page.
       The chips read fine as plain text after the link. */
    var seen = {};
    var count = 0;
    for (var j = 0; j < vals.length; j++) {
      var label = labelFor(vals[j]);
      if (label === null) continue;
      if (has(seen, "k" + label)) continue;  /* "1 Liter" and "1 Liters" both
                                                normalise to "1 L" */
      seen["k" + label] = 1;

      var chip = document.createElement("span");
      var isMore = OVERFLOW.test(label);
      chip.className = isMore
        ? "ps-chips__item ps-chips__item--more"   /* a counter, not a size -- give
                                                     the CSS a way to style it
                                                     differently from a real chip */
        : "ps-chips__item";
      chip.textContent = label;
      /* "+1" announces as "plus one", which is noise rather than information:
         the four visible sizes already say "this comes in sizes", and the full
         list is on the product page. Hidden from assistive tech rather than
         given an aria-label, because that label would need an Arabic variant
         and inventing store copy is not this file's job. If Abdo rules on the
         wording, delete this line and set the label instead. */
      if (isMore) chip.setAttribute("aria-hidden", "true");
      row.appendChild(chip);
      count++;
    }
    return count ? row : null;   /* never append an empty .ps-chips: it would
                                    still take up the row's reserved height once
                                    primostore-system.css ships that rule */
  }

  function decorate(root) {
    var cards = (root || document).querySelectorAll(".grid-product__content");
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      if (card.getAttribute("data-ps-chips") === "done") continue;
      var link = card.querySelector('a[href*="/products/"]');
      if (!link) continue;

      card.setAttribute("data-ps-chips", "done");   /* mark either way, so a
                                                       card with no sizes is
                                                       not re-scanned forever */

      var handle = handleFrom(link.getAttribute("href"));
      if (handle === null || !has(SIZES, handle)) continue;
      var vals = SIZES[handle];
      if (!Array.isArray(vals) || !vals.length) continue;

      var row = buildRow(vals);
      if (row) insertRow(card, row);
    }
  }

  /* -------------------------------------------------------------- observer -- */

  var observer = null;
  var pending = null;
  var started = false;

  /* Scoped to the grid, not document.body. Impulse's AjaxRenderer replaces
     #CollectionAjaxContent's innerHTML on filter/sort, so that element itself
     survives and a childList+subtree observer on it keeps firing across every
     re-render. Watching the body instead meant every Judge.me badge, StarApps
     image swap, BOGOS gift and chat-launcher insertion scheduled a full
     document-wide sweep. Re-resolved on each sweep so that if the container is
     ever swapped wholesale rather than refilled, the observer follows it. */
  function observerRoot() {
    return document.getElementById("CollectionAjaxContent")
        || document.getElementById("MainContent")
        || document.body
        || document.documentElement;
  }

  function schedule() {
    clearTimeout(pending);
    pending = setTimeout(sweep, 60);
  }

  /* THE SELF-RETRIGGER FIX. Every insertRow() is itself a childList mutation
     inside the observed subtree, so the old code guaranteed at least one extra
     full sweep per cycle. The observer is disconnected for the duration of the
     write and reconnected after.

     WHY THIS CANNOT LIVELOCK, and why it cannot miss anything either:
       - decorate() is synchronous and JavaScript is single-threaded, so no other
         script can mutate the DOM inside the disconnected window; nothing is lost
         by not listening during it. disconnect() also empties the pending record
         queue, so our own appends are never delivered.
       - Even if a record did slip through, data-ps-chips="done" means the next
         sweep finds nothing to decorate, appends nothing, and therefore generates
         no mutation. The chain is bounded at one extra no-op pass, not a loop.
       - A DOM exception inside decorate() cannot leave the observer detached,
         because the reconnect is in a finally. */
  function sweep() {
    if (observer) observer.disconnect();
    try {
      decorate(document);
    } finally {
      if (observer) {
        observer.observe(observerRoot(), { childList: true, subtree: true });
      }
    }
  }

  function onMutations(records) {
    for (var i = 0; i < records.length; i++) {
      var added = records[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        /* Belt and braces with the disconnect above: ignore our own rows and
           chips if a record ever reaches here. Removal-only records are ignored
           too -- a card that left the DOM needs no decorating. */
        if (node.nodeType === 1 && node.classList &&
            (node.classList.contains("ps-chips") ||
             node.classList.contains("ps-chips__item"))) continue;
        schedule();
        return;
      }
    }
  }

  /* Everything that touches document.body lives in here, and here only runs once
     the body exists. The observer used to be installed at IIFE time, outside this
     guard: dropped in <head> without defer, document.body was null and
     .observe() threw "parameter 1 is not of type 'Node'", killing the rest of the
     IIFE. First paint still worked because the DOMContentLoaded listener was
     already attached, so the failure was invisible -- but the re-decorate on
     filter and sort, the entire reason the observer exists, was silently gone. */
  function start() {
    if (started) return;
    started = true;

    if (window.MutationObserver) observer = new MutationObserver(onMutations);

    /* Impulse's own hook, dispatched at the end of renderCollectionPage(). It is
       exact and free, so the observer is the safety net for app-driven appends
       (ScrollerPro's infinite scroll) rather than the primary trigger. */
    document.addEventListener("collection:reloaded", schedule);

    sweep();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();
